module.exports = __webpack_public_path__ + "static/media/AWS_PC_Installation_SpeedUp_noNotes.f638941a.png";